import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../../public/fonts/poppins-regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/poppins-medium.woff2\",\"weight\":\"500\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/poppins-semibold.woff2\",\"weight\":\"600\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/poppins-bold.woff2\",\"weight\":\"700\",\"style\":\"normal\"}],\"variable\":\"--font-poppins\",\"preload\":false}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../../public/fonts/gtultramedian-light.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/gtultramedian-bold.woff2\",\"weight\":\"600\",\"style\":\"normal\"}],\"variable\":\"--font-gtUltra\"}],\"variableName\":\"gtUltra\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/blog/components/BlogShareBar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(web)/components/common/AnimateOnViewport.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/components/common/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/components/common/ClinicsSelector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/components/common/DynamicIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/components/common/ProfessionalCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/components/common/ReviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/components/common/SetApplicationOrigin.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(web)/components/home/FloatingBottomBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/components/home/FloatingBottomBarPv.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/components/layout/AnalyticsMetrics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/components/layout/AppointmentButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/components/layout/ContentViewEvent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/components/layout/FooterSecondBlockClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/components/layout/Header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(web)/components/product/fullWidthCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/tratamientos/[slug]/components/GoToPVButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/tratamientos/[slug]/components/LongevityImgHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/tratamientos/[slug]/components/ProductImagesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/tratamientos/[slug]/components/ProductInfo.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(web)/tratamientos/[slug]/components/ProductPriceCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/tratamientos/[slug]/components/ProductPricesSurgerySSR.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(web)/tratamientos/[slug]/components/ProductSelectorButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(web)/tratamientos/[slug]/components/ProductSessionPriceCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/tratamientos/[slug]/components/ProductSuggestions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/tratamientos/[slug]/components/ProductSurgeryExplanation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/tratamientos/[slug]/components/ProductVideos.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(web)/tratamientos/[slug]/components/PVCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(web)/tratamientos/[slug]/components/VithasGroup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/utils/CheckHydration.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/designSystem/Accordion/SimpleAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/designSystem/Carousel/Carousel.tsx");
